export default (that) => [
    {
        field: 'seq',
        width: 40,
        align: 'center',
        fixed: 'left',
        type: 'seq'
      },
      {
        title: that.$l('goods_label_scheduleDate') || '计划日期',
        field: 'scheduleDate',
        headerAlign: 'center',
        align: 'center',
        minWidth: 150,
        showHeaderOverflow: true,
        showOverflow: true
      },
      {
        title: that.$l('goods_label_needQty') || '需求数量',
        field: 'needQty',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        showHeaderOverflow: true,
        showOverflow: true
      },
      {
        title: that.$l('goods_label_hasQty') || '已采购数',
        field: 'hasQty',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        showHeaderOverflow: true,
        showOverflow: true
      },
      {
        title: that.$l('goods_label_stockQty') || '已入库数',
        field: 'stockQty',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        showHeaderOverflow: true,
        showOverflow: true
      },
      {
        title: that.$l('INDEX.table_label_modified_by') || '修改人姓名',
        field: 'modifyByName',
        align: 'center',
        width: 100,
        showHeaderOverflow: true,
        showOverflow: true,
      },
      {
        title: that.$l('INDEX.table_label_modification_date') || '修改时间',
        field: 'modifyDate',
        align: 'center',
        width: 170,
        showHeaderOverflow: true,
        showOverflow: true,
      },
]